/*
 Created by qing on 2020/12/29
 Des:
 */
import AppsConfig from "./AppsConfig";
import DashboardConfig from "./DashboardConfig";
import QuickEntryConfig from "./QuickEntryConfig";
import TodoConfig from "./TodoConfig";
import ContactMe from "./ContactMe";

export default {
  AppsConfig,
  DashboardConfig,
  QuickEntryConfig,
  TodoConfig,
  ContactMe
}
